export const gui = async (args: string[]): Promise<string> => {
  window.open('https://andythsu.github.io', '_blank');

  return 'Opening GUI version...';
};
